import { useTranslation } from "react-i18next";
import React from "react";

interface Guest {
  name: string;
  phone: string;
  email: string;
}

interface GuestInfoProps {
  guest: Guest;
}

const GuestInfo: React.FC<GuestInfoProps> = ({ guest }) => {
  const { t } = useTranslation();
  return (
    <div className="} rounded-[1.25rem] border border-[#DCDCDC] p-[1.25rem] pr-[6.25rem] pt-[1.3125rem]">
      <div className="">
        <div className="flex flex-col gap-[0.9375rem]">
          <p className="text-base font-semibold">{t("Guest information")}</p>

          <div className="flex justify-start">
            <p className="flex w-[22rem] text-[0.875rem] font-semibold">
              {t("Name")}
            </p>
            <div className="flex w-[29.5625rem] items-center justify-between text-[0.875rem]">
              <p className="font-normal text-[#232323]">{guest.name}</p>
            </div>
          </div>

          <div className="flex justify-start">
            <p className="flex w-[22rem] text-[0.875rem] font-semibold">
              {t("Phone")}
            </p>
            <div className="flex w-[29.5625rem] items-center justify-between">
              <p className="text-[0.875rem] font-normal text-[#232323]">
                {guest.phone}
              </p>
            </div>
          </div>

          <div className="flex justify-start">
            <p className="flex w-[22rem] text-[0.875rem] font-semibold">
              {t("Email")}
            </p>
            <div className="flex w-[29.5625rem] items-center justify-between">
              <p className="text-[0.875rem] font-normal text-[#232323]">
                {guest.email}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestInfo;
